import React from 'react'
import styled from '@emotion/styled'
import { ActiveButton, DisabledButton } from '../shared/CycleButtonComponent';
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';

const CircleMenu = styled.div`
    position: static;
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    width: 60rem;
    height: 15rem;

@media (max-width: 500px){
    width: 40rem;
}
`;
const CircleContainer = styled.div`
    display:flex;
    flex-direction:column;
    align-items:center;
    height: 7rem;
    justify-content:space-between;

    .cover{
        display:flex;
        width: 5rem;
        height: 5rem;
        align-items:center;
        /* default/shade/white */
        justify-content:center;
        background: #FFFFFF;
        /* default/gray/300 */

        border: 1px solid #D3D9DE;
        box-sizing: border-box;
        border-radius: 8.75rem;
    }
    .cover > img{
        width:50%;
        height:50%;
        object-fit:contain;
        align-self:center;
        margin: 0 auto;
      
        
    }
    .box{
        background-image: url(/products/coils.jpg);
        background-repeat: no-repeat;
        width: 6.3rem;
        height: 5.6rem;
        align-items:center;
       
        border-radius: 0rem;
    }
    .name{
        text-align: center;
    }
    @media (max-width: 500px){
        height: 8rem;
    }
    /* @media (max-width: 768px){
        :nth-of-type(1){
            opacity:0.25;
        }
        :nth-of-type(5){
            opacity:0.25;
        }
    }
    @media (max-width: 425px){
        :nth-of-type(2){
            opacity:0.25
        }
        :nth-of-type(4){
            opacity:0.25
        }
    } */
`;
function Sample() {
    
        return (
            <CircleMenu>
                {/* <DisabledButton/> */}
                <Carousel
                            slidesPerPage={5}
                            arrowLeft={<DisabledButton/>}
                            arrowRight={<ActiveButton/>}
                            addArrowClickHandler
                            infinite>
                <CircleContainer>
                    <div className="cover">
                    <img src="/products/coils.jpg" alt="Coils"/>
                    </div>
                    <p className="name">Detachable Coils</p>
                </CircleContainer>
                <CircleContainer>
                    <div className="cover">
                        <img src="/products/guidewire.jpg" alt="Guidewire"/>
                    </div>
                    <p className="name">Guide Wire</p>
                </CircleContainer>
                <CircleContainer>
                    <div className="cover">
                        <img src="/products/airway.jpg" alt="Airway"/>
                        </div>
                    <p className="name">Airway Management</p>
                </CircleContainer>
                <CircleContainer>
                    <div className="cover">
                        <img src="/products/syringe.jpg" alt="Syringe"/>
                        </div>
                    <p className="name">Entry Needles</p>
                </CircleContainer>
                <CircleContainer>
                        <div className="cover">
                            <img src="/products/needle.jpg" alt="Needle"/>
                        </div>
                    <p className="name">Entry Needles</p>
                </CircleContainer>
                {/* <ActiveButton/> */}
                </Carousel>
            </CircleMenu>
            
        )
    
}

export default Sample
